<template>
  <div id="app" :class="{ 'hide-nav-footer': hideNavFooter }">
    <NavBar
      :auth-token="user?.token || ''"
      @show-login="toggleLoginPopup"
      @logout="handleLogout"
    />

    <MessagePopup
      :visible="globalShowPopup"
      :message="globalPopupMessage"
      :type="globalPopupType"
    />

    <router-view
      @show-login-popup="toggleLoginPopup"
      @show-popup-message="showPopupMessage"
      @toggle-nav-footer="toggleNavFooter"
    />

    <Footer />

    <Login
      v-if="showLogin"
      :showLogin="showLogin"
      @close="toggleLoginPopup"
      @show-register="switchToRegisterPopup"
      @login-success="handleLoginSuccess"
    />

    <Register
      v-if="showRegister"
      :showRegister="showRegister"
      @close="toggleRegisterPopup"
      @show-login="switchToLoginPopup"
      @register-success="handleRegisterSuccess"
    />

    <ComicTipDialog />
    <VolPayDialog />
    <GoldRechargeDialog />
    <AgreementDialog />
  </div>
</template>

<script setup>
import NavBar from '@/shared/components/NavBar.vue'
import Footer from '@/shared/components/Footer.vue'
import Login from '@/features/user/components/Login.vue'
import Register from '@/features/user/components/Register.vue'
import MessagePopup from '@/features/message/components/MessagePopup.vue'
import ComicTipDialog from '@/features/comic/components/ComicTipDialog.vue'
import VolPayDialog from '@/features/comic/components/VolPayDialog.vue'
import GoldRechargeDialog from '@/features/user/components/GoldRechargeDialog.vue'
import AgreementDialog from '@/features/comic/components/AgreementDialog.vue'
import { useAppShell } from '@/shared/composables/useAppShell'

const {
  showLogin,
  showRegister,
  user,
  globalPopupMessage,
  globalPopupType,
  globalShowPopup,
  hideNavFooter,
  toggleLoginPopup,
  toggleRegisterPopup,
  switchToRegisterPopup,
  switchToLoginPopup,
  handleRegisterSuccess,
  handleLoginSuccess,
  handleLogout,
  showPopupMessage,
  toggleNavFooter,
} = useAppShell()
</script>

<style src="./styles/App.css"></style>
